import {Location} from "@components/Booking/LocationSelection/types";
import {useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";
import {isEvenHour} from "../../../../../../../../hooks/useReadableSlotTime";
import moment from "moment";
import getTimezone from "../../../../../../../../utils/getTimezone";
import HoursOfOperation from "./HoursOfOperation";
import React from "react";

const NextSlotTime = ({location, time}: {location: Location; time: number}) => {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  const sameDay = `${i18n.t("Today", {ns: "web-scheduling"})}`;
  const nextDay = `${i18n.t("Tomorrow", {ns: "web-scheduling"})}`;
  const timeFormat = isEvenHour(time) ? "ha" : "h:mma";
  const theMoment = moment(time).tz(location?.timezone ?? getTimezone());

  const format = {
    sameDay: `[${sameDay}] ${timeFormat}`,
    nextDay: `[${nextDay}] ${timeFormat}`,
    nextWeek: `ddd ${timeFormat}`,
    sameElse: `MMM D ${timeFormat}`,
  };
  const formattedTime = theMoment.calendar(null, format);
  return (
    <span className="text-sm font-i">
      <span className="text-green-600 font-semibold">{formattedTime}</span>
      <span> · </span>
      <HoursOfOperation disabled={false} location={location} />
    </span>
  );
};

export default React.memo(NextSlotTime);
